import revive_payload_client_4sVQNw7RlN from "/Users/mile/Projekti/bigbang.si/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/Users/mile/Projekti/bigbang.si/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/Users/mile/Projekti/bigbang.si/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/Users/mile/Projekti/bigbang.si/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/Users/mile/Projekti/bigbang.si/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/Users/mile/Projekti/bigbang.si/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_immediate_client_xfI97IMoyr from "/Users/mile/Projekti/bigbang.si/node_modules/nuxt/dist/app/plugins/chunk-reload-immediate.client.js";
import components_plugin_KR1HBZs4kY from "/Users/mile/Projekti/bigbang.si/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/Users/mile/Projekti/bigbang.si/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import nuxt_plugin_6wEQMY3tee from "/Users/mile/Projekti/bigbang.si/node_modules/nuxt-delay-hydration/dist/runtime/nuxt-plugin.js";
import _01_init_ETHgJv5vq1 from "/Users/mile/Projekti/nuxt-base/plugins/01.init.js";
import _02_init_client_jt1u2Ep9M3 from "/Users/mile/Projekti/nuxt-base/plugins/02.init.client.js";
import idle_client_J2uHOlMj4u from "/Users/mile/Projekti/nuxt-base/plugins/idle.client.js";
import interpolation_aKdFYVeXpg from "/Users/mile/Projekti/nuxt-base/plugins/interpolation.js";
import _01_frosmo_client_PC8CDzOf4M from "/Users/mile/Projekti/bigbang.si/plugins/01.frosmo.client.js";
import affiliate_lite_client_oJ936Ihbm7 from "/Users/mile/Projekti/bigbang.si/plugins/affiliate_lite.client.js";
import catalog_client_31JhSSjMe1 from "/Users/mile/Projekti/bigbang.si/plugins/catalog.client.js";
import preload_client_LgeXWGnMMh from "/Users/mile/Projekti/bigbang.si/plugins/preload.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_immediate_client_xfI97IMoyr,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  nuxt_plugin_6wEQMY3tee,
  _01_init_ETHgJv5vq1,
  _02_init_client_jt1u2Ep9M3,
  idle_client_J2uHOlMj4u,
  interpolation_aKdFYVeXpg,
  _01_frosmo_client_PC8CDzOf4M,
  affiliate_lite_client_oJ936Ihbm7,
  catalog_client_31JhSSjMe1,
  preload_client_LgeXWGnMMh
]